import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Info = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M11 11.438h1v5m9-4a9 9 0 1 1-18 0 9 9 0 0 1 18 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <rect
          x='11.25'
          y='7.688'
          width='1.5'
          height='1.5'
          rx='0.75'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.5'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 12.438c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10m9-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 3a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0v-4.5h-.5a.75.75 0 0 1-.75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
